import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { REMOTE_IMAGE_DETAIL_PAGE_TYPE } from '../../../../../constants/service/app/remoteImageConstants';
import './RemoteImageSplashDetailNavbar.scss';

const RemoteImageSplashDetailNavbar = (props) => {
  const { detailPageType, remoteImageSplashDetail, onSubmit } = props;
  const { memo, remoteImg, imgUrl } = remoteImageSplashDetail;

  return (
    <FixedBottomNavBar className="remote-image-detail-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text={detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.CREATE ? '등록하기' : '저장하기'}
          onClick={() =>
            onSubmit({
              memo,
              remoteImg,
              imgUrl,
            })
          }
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default RemoteImageSplashDetailNavbar;
